import React, {useState} from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"
import baseURL from "../Url/Url.jsx";

const PilihPeriode = ({
    bulan,
    perusahaan,
    tahunSekarang,
}) => {
    const [bulann, setBulann] = useState("Bulan")
    const [tahun, setTahun] = useState("Tahun")
    const navigate = useNavigate();
    // Pilih Periode
    const pilihPeriode = async(e)=>{
        e.preventDefault()
        try {
            await axios.patch(`${baseURL}/pilihPeriodeBE`,{
                perusahaan: perusahaan,
                bulan: bulann,
                tahun: tahun,
            })
            navigate(`/menu-dashboard/${perusahaan}/${bulann}/${tahun}`, { replace: true })
            window.location.reload()
        } catch (error) {
            if(error.response){
                console.log(error.response.data.msg)
            }
        }
    }
    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-6 mt-5">
                    <div className="box mt-5 p-4">
                        <div className="modal-body">
                            <h5 className="text-center fw-bold mt-3 mb-4">Silahkan Untuk Pilih Periode</h5>
                            <form onSubmit={pilihPeriode}>
                                <div className="row px-4">
                                    <div className="col-12 col-md-6 mb-3">
                                        <select className="form-select form text-center" id="bulan" aria-label="bulan" value={bulann} onChange={(e)=>setBulann(e.target.value)} required>
                                            <option defaultValue={bulan}>Bulan</option>
                                            <option defaultValue="JANUARI">JANUARI</option>
                                            <option defaultValue="FEBRUARI">FEBRUARI</option>
                                            <option defaultValue="MARET">MARET</option>
                                            <option defaultValue="APRIL">APRIL</option>
                                            <option defaultValue="MEI">MEI</option>
                                            <option defaultValue="JUNI">JUNI</option>
                                            <option defaultValue="JULI">JULI</option>
                                            <option defaultValue="AGUSTUS">AGUSTUS</option>
                                            <option defaultValue="SEPTEMBER">SEPTEMBER</option>
                                            <option defaultValue="OKTOBER">OKTOBER</option>
                                            <option defaultValue="NOVEMBER">NOVEMBER</option>
                                            <option defaultValue="DESEMBER">DESEMBER</option>
                                        </select>
                                    </div>
                                    <input type="text" className="form-disable" value={perusahaan} readOnly/>
                                    <div className="col-12 col-md-6 mb-3">
                                        <select className="form-select form text-center" id="tahun" aria-label="tahun" value={tahun} onChange={(e)=>setTahun(e.target.value)} required>
                                            <option defaultValue={tahunSekarang}>Tahun</option>
                                            <option defaultValue="2020">2020</option>
                                            <option defaultValue="2021">2021</option>
                                            <option defaultValue="2022">2022</option>
                                            <option defaultValue="2023">2023</option>
                                            <option defaultValue="2024">2024</option>
                                            <option defaultValue="2025">2025</option>
                                            <option defaultValue="2026">2026</option>
                                            <option defaultValue="2027">2027</option>
                                            <option defaultValue="2028">2028</option>
                                            <option defaultValue="2029">2029</option>
                                            <option defaultValue="2030">2030</option>
                                            <option defaultValue="2031">2031</option>
                                            <option defaultValue="2032">2032</option>
                                            <option defaultValue="2033">2033</option>
                                            <option defaultValue="2034">2034</option>
                                            <option defaultValue="2035">2035</option>
                                            <option defaultValue="2036">2036</option>
                                            <option defaultValue="2037">2037</option>
                                            <option defaultValue="2038">2038</option>
                                            <option defaultValue="2039">2039</option>
                                            <option defaultValue="2040">2040</option>
                                            <option defaultValue="2041">2041</option>
                                            <option defaultValue="2042">2042</option>
                                            <option defaultValue="2043">2043</option>
                                            <option defaultValue="2044">2044</option>
                                            <option defaultValue="2045">2045</option>
                                            <option defaultValue="2046">2046</option>
                                            <option defaultValue="2047">2047</option>
                                            <option defaultValue="2048">2048</option>
                                            <option defaultValue="2049">2049</option>
                                            <option defaultValue="2050">2050</option>
                                        </select>
                                    </div>
                                    <input type="submit" className="btn btn-webew-login mb-4 mt-3" value="Oke"/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PilihPeriode